import React from 'react';
import { Field, FieldArray } from 'redux-form';
import { Button, Row, Col } from 'reactstrap';
import PlusCircleOutlineIcon from 'mdi-react/PlusCircleOutlineIcon';
import DeleteOutlineIcon from 'mdi-react/DeleteOutlineIcon';
import renderField from '../../../shared/components/custom/Field';
import { partial } from '../../../util/translation/translation';
import TooltipWithIcon from '../../../shared/components/custom/TooltipWithIcon';
import SquareIconButton from '../../../shared/components/custom/SquareIconButton';

const PopularAmountsFields = ({ fields, meta, currency, step }) => {
  const s = partial('shared');
  const p = partial('goalSponsor');
  const { error, submitFailed } = meta;

  return (
    <div className="form__form-group">
      <span className="form-header">
        {p('popularAmounts')}* &nbsp;
        <TooltipWithIcon
          id="popular-amounts-tooltip"
          text={p('popularAmountsDescription')}
        />
      </span>
      <div
        style={{
          background: 'rgba(244, 244, 246, 1)',
          border: '1px solid rgba(0, 0, 0, 0.08)',
          borderRadius: 4,
          padding: '14px 16px',
        }}
      >
        <Row>
          {fields.map((field, index) => (
            <Col md={4} sm={6} key={field}>
              <div className="form__form-group">
                <span className="form-header">
                  {p('goalsLabel')} {index + 1}
                </span>
                <div className="d-flex align-items-start">
                  <div className="form__form-group-field flex-grow-1">
                    <Field
                      name={field}
                      component={renderField}
                      type="number"
                      min={1}
                      step={step}
                      placeholder={p('popularAmount')}
                    />
                    <div className="form__form-group-icon">
                      &nbsp;{currency}&nbsp;
                    </div>
                  </div>
                  {fields.length > 1 && (
                    <div className="marginLeft-8">
                      <SquareIconButton
                        icon={<DeleteOutlineIcon />}
                        onClick={() => fields.remove(index)}
                        title={s('remove')}
                        tone="danger"
                        id={`popular-amount-remove-${index}`}
                      />
                    </div>
                  )}
                </div>
              </div>
            </Col>
          ))}
        </Row>
        {submitFailed && error && (
          <span className="form__form-group-error">{error}</span>
        )}
        <Button
          type="button"
          color="success"
          size="sm"
          className="marginBottom-0"
          onClick={() => fields.push('')}
        >
          {p('addPopularAmount')}
          <PlusCircleOutlineIcon className="icon-24 marginLeft-8" />
        </Button>
      </div>
    </div>
  );
};

// `step`: "any" for plans that take amounts under 1 kr
const PopularAmountsField = ({ currency, step }) => (
  <FieldArray
    name="popularAmounts"
    component={PopularAmountsFields}
    currency={currency}
    step={step}
  />
);

export default PopularAmountsField;
